import Vue from "vue";
import Router from "vue-router";
import Layout from "@/views/layout/Layout";
const originalPush = Router.prototype.push;

Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(Router);

export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
  {
    path: "/404",
    component: () => import("@/views/errorPage/404"),
    hidden: true,
  },
  {
    path: "/401",
    component: () => import("@/views/errorPage/401"),
    hidden: true,
  },
  {
    path: "/",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
];

export const asyncRouterMap = [
  // {
  //   path: "/layout",
  //   component: Layout,
  //   redirect: "/layout/videoList",
  //   hidden: true,
  //   children: [
  //     {
  //       path: "videoList",
  //       component: () => import("@/views/videoList/videoList/index"),
  //       name: "videoList",
  //       meta: {
  //         title: "视频回流",
  //         icon: "video",
  //         noCache: true,
  //       },
  //     },
  //     {
  //       path: "feedback",
  //       component: () => import("@/views/feedback/feedback/index"),
  //       name: "feedback",
  //       hidden: true,
  //       meta: {
  //         title: "用户反馈",
  //         icon: "dashboard",
  //         noCache: true,
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: "/userAdmin",
  //   component: Layout,
  //   name:'用户管理',
  //   children: [
  //     {
  //       path: "userList",
  //       component: () => import("@/views/userAdmin/userList"),
  //       name: "userList",
  //       meta: {
  //         title: "用户列表",
  //         icon: "dashboard",
  //         noCache: true,
  //       },
  //     },
  //     {
  //       path: "roleList",
  //       component: () => import("@/views/userAdmin/roleList"),
  //       name: "roleList",
  //       meta: {
  //         title: "角色列表",
  //         icon: "dashboard",
  //         noCache: true,
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: '/courseAdmin',
  //   component: Layout,
  //   name: '课程管理',
  //   icon: 'el-icon-s-management',
  //   children: [
  //     {
  //       path: "",
  //       name: "material",
  //       redirect: 'material/videoAdmin',
  //       icon: "el-icon-setting",
  //       component: () => import("@/views/courseAdmin/material"),
  //       meta: {
  //         title: "素材库配置",
  //         icon: "el-icon-setting",
  //         noCache: true,
  //       },
  //       children: [
  //         {
  //           path: "material/videoAdmin",
  //           component: () => import("@/views/courseAdmin/material/videoAdmin"),
  //           name: "videoAdmin",
  //           meta: {
  //             title: "视频配置",
  //             icon: "el-icon-video-play",
  //             noCache: true,
  //           },
  //         },
  //         {
  //           path: "material/audioAdmin",
  //           component: () => import("@/views/courseAdmin/material/audioAdmin"),
  //           name: "material",
  //           meta: {
  //             title: "音频配置",
  //             icon: "el-icon-mic",
  //             noCache: true,
  //           },
  //         }
  //       ]
  //     },
  //     {
  //       path: "motion",
  //       component: () => import("@/views/courseAdmin/motion"),
  //       name: "motion",
  //       icon: "el-icon-s-order",
  //       meta: {
  //         title: "动作库配置",
  //         icon: "el-icon-s-order",
  //         noCache: true,
  //       },
  //     },
  //   ]
  // },
  // { path: "*", redirect: "/login", hidden: true },
];

const router = new Router({
  // mode: 'history', 
  base: '/jialian',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
});

export default router